import { render } from "./gmQuery.vue?vue&type=template&id=c65197fe&scoped=true"
import script from "./gmQuery.vue?vue&type=script&lang=js"
export * from "./gmQuery.vue?vue&type=script&lang=js"

import "./gmQuery.vue?vue&type=style&index=0&id=c65197fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c65197fe"

export default script